/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateCampaignScheduleDataSchema = z.object({
	startDate: z.iso.datetime().nullable().optional(),
	endDate: z.iso.datetime().nullable().optional(),
})

export type UpdateCampaignScheduleDataSchema = z.infer<typeof updateCampaignScheduleDataSchema>
